import { inject, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GtmInjectScriptsDirective } from '@cal-analytics/gtm';
import { CalScanCloudModule, SCAN_CLOUD_CONFIG } from '@calsale/scanovate';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { GtmAdapterModule } from '@partners/gtm';
import { CommonScanCloudConfig, EnvironmentService } from '@partners/kernel';
import {
  AppInitializerDirective,
  ApplicationViewComponent,
  DebuggerComponent,
  FeatureShellModule,
  ProgressTrackerDirective
} from '@partners/shell';
import { StateModule } from '@partners/state';
import { UTM_CONFIG, UTM_PARAMS, UtmModule } from '@partners/utm';
import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';
import { environment } from '../environments/environment';
import { AppRouterModule } from './app-router.module';
import { AppHostComponent } from './app.component';

@NgModule({
  providers: [
    { provide: LOCALE_ID, useValue: 'he' },
    provideLottieOptions({
      player: () => player
    })
  ],
  declarations: [AppHostComponent],
  imports: [
    BrowserModule,
    AppRouterModule,
    ProgressTrackerDirective,
    GtmInjectScriptsDirective,
    StateModule,
    GtmAdapterModule.forRoot(environment.gtmConfig),
    CalScanCloudModule.forRoot({
      provide: SCAN_CLOUD_CONFIG,
      useClass: CommonScanCloudConfig
    }),
    FeatureShellModule.forRoot({
      environment: environment,

      urlParams: [
        'token',
        'uid',
        'partner',
        'brandCode',
        'lobCode',
        'saleOfferCode',
        'salePointCode',
        'view',
        'recommenderId',
        'profileCode',
        'triggerCode',
        'theme',
        'acMan',
        'ignoreNavigation'
      ]
    }),
    UtmModule.forRoot([
      {
        provide: UTM_PARAMS,
        useValue: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
      },
      {
        provide: UTM_CONFIG,
        useFactory: () => ({ calEdaUri: inject(EnvironmentService).calEdaUri$$() })
      }
    ]),
    AppInitializerDirective,
    ApplicationViewComponent,
    BrowserAnimationsModule,
    StoreDevtoolsModule.instrument(),
    DebuggerComponent
  ],
  bootstrap: [AppHostComponent]
})
export class AppModule {}
